import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery, useTheme } from "@mui/material";

const InsightsAnimation = ({ isVisible, onAnimationComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const insightsItems = [
    "Sub skills",
    "Enterprise Adoption",
    "Latest Technologies",
    "Suggested Roles",
    "Other Roles with Responsibilities",
    "Courses",
    "Career Path",
    "Annual Income Based on Years of Experience",
    // "Annual income by role",
    "Top Interview Questions",
    "Game-Changers That Could Redefine Your Career and Key Skills",
  ];

  useEffect(() => {
    if (!isVisible) {
      setCurrentIndex(0);
      if (onAnimationComplete) {
        onAnimationComplete();
      }
      return;
    }

    // Change text every 2 seconds
    const textInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % insightsItems.length);
    }, 2000);

    return () => {
      clearInterval(textInterval);
    };
  }, [isVisible, insightsItems.length, onAnimationComplete]);

  if (!isVisible) return null;

  return (
    <Box sx={{ textAlign: "center" }}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "poppins",
              fontSize: { xs: "16px", sm: "20px", md: "22px" },
              fontWeight: 600,
              color: "#495057",
              lineHeight: 1.4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: 0.5, sm: 1 },
              flexWrap: "wrap",
              px: { xs: 1, sm: 2 },
            }}
          >
            <span>Generating</span>
            <motion.span
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.5, repeat: Infinity }}
              style={{ color: "#007bff" }}
            >
              {insightsItems[currentIndex]}
            </motion.span>
          </Typography>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default InsightsAnimation;
